import "./App.css";
import Layout from "./Layout/layout";
import HeroPage from "./Components/heroPage";
import WhyChooseUs from "./Components/WhyChooseUs";
import Footer from "./Components/footer";

function App() {
  return (
    <div className="App">
      <Layout />
      <HeroPage />
      <WhyChooseUs/>
      <Footer/>
    </div>
  );
}

export default App;